import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaTelegramPlane, FaTiktok, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import prinzetunerLogo from '../../assets/logo.png';
import './footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-heading">
      <h1 className="gradient__text">Ready to Unlock the Full Potential of Your ECU?</h1>
    </div>

    <div className="gpt3__footer-btn">
      <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer">
        <p>Contact Us Today</p>
      </a>
    </div>

    <div className="gpt3__footer-links">
      <div className="gpt3__footer-links_main">
        <div className="gpt3__footer-links_logo">
          <div className="gpt3__footer-links_logo-container">
            <img src={prinzetunerLogo} alt="Prinzetuner_logo" />
            <h1>Prinzetuner</h1>
          </div>
          <p>Advanced ECU Solutions for Professionals, <br /> All Rights Reserved</p>
          <div className="gpt3__footer-developer">
            <h4>Developer</h4>
            <p>Imran Mohd</p>
          </div>
        </div>

        <div className="gpt3__footer-links_div gpt3__footer-contact">
          <h4>Get in touch</h4>
          <div className="gpt3__footer-contact_item">
            <FaPhoneAlt className="footer-icon" />
            <p><a href="tel:+966590707424">+966 590 707 424</a></p>
          </div>
          <div className="gpt3__footer-contact_item">
            <FaEnvelope className="footer-icon" />
            <p><a href="mailto:prinze902@gmail.com">prinze902@gmail.com</a></p>
          </div>
          <div className="gpt3__footer-contact_item">
            <FaTiktok className="footer-icon" />
            <p><a href="https://www.tiktok.com/@Prinzetuner" target="_blank" rel="noreferrer">@Prinzetuner</a></p>
          </div>
          <div className="gpt3__footer-contact_item">
            <FaTelegramPlane className="footer-icon" />
            <p><a href="https://t.me/Prinzetuner" target="_blank" rel="noreferrer">@Prinzetuner</a></p>
          </div>
          <div className="gpt3__footer-contact_item">
            <FaWhatsapp className="footer-icon" />
            <p><a href="https://wa.me/966590707424" target="_blank" rel="noreferrer">WhatsApp Chat</a></p>
          </div>
        </div>
      </div>

      <div className="gpt3__footer-links_div">
        <h4>Solutions</h4>
        <p><Link to="/file-service">File Service</Link></p>
        <p><Link to="/support-list">Support List</Link></p>
        <p><a href="/#products">IMMO OFF</a></p>
        <p><a href="/#products">CAT OFF</a></p>
        <p><a href="/#products">DTC Management</a></p>
        <p><a href="/#products">System Disable</a></p>
      </div>

      <div className="gpt3__footer-links_div">
        <h4>Company</h4>
        <p><Link to="/terms">Terms & Conditions</Link></p>
        <p><Link to="/privacy">Privacy Policy</Link></p>
        <p><Link to="/about">About Us</Link></p>
      </div>
    </div>

    <div className="gpt3__footer-copyright">
      <p>@2026 Prinzetuner. All rights reserved.</p>
    </div>
  </div>
);

export default Footer;
